import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import rjApiSlice from "./rj"
import caesarApiSlice from "./caesar";
import { rjTriggerApi, caesarTriggerApi } from "./config";
const store = configureStore({
  reducer: {
    [rjApiSlice.reducerPath]: rjApiSlice.reducer,
    [caesarApiSlice.reducerPath] : caesarApiSlice.reducer,
  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ thunk: true }).concat(
      rjTriggerApi.middleware,
      caesarTriggerApi.middleware,
    ),

  devTools: process.env.NODE_ENV !== "production",
});

setupListeners(store.dispatch);

export default store;
